import React from "react";
import { GraduationCap } from "lucide-react";
import { useLang } from "@/i18n";
import useContent from "@/hooks/useContent";
import { DarkPage, Reveal, SectionKicker, HowBetoolWorks, FinalCta } from "@/components/marketing";

export default function Academy() {
  const { t } = useLang();
  const content = useContent();
  return (
    <DarkPage>
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-16">
        <Reveal className="max-w-2xl mb-10">
          <SectionKicker><GraduationCap size={13} className="inline" /> Academy</SectionKicker>
          <h1 className="font-head font-black text-4xl sm:text-5xl tracking-tight mb-3">{t("academy2_title")}</h1>
          <p className="text-zinc-400 text-lg">{t("academy2_sub")}</p>
        </Reveal>

        {/* Intro — the official BETOOL presentation video will be added here later */}
        <Reveal className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="font-head font-black text-3xl sm:text-4xl tracking-tight mb-3">{t("academy_intro_title")}</h2>
          <p className="text-zinc-400 text-lg">{t("academy_intro_sub")}</p>
        </Reveal>

        {/* Visual step-by-step explainer */}
        <div className="mb-24">
          <HowBetoolWorks showCta={false} />
        </div>
      </section>
      <FinalCta content={content} />
    </DarkPage>
  );
}
